export class FeesClientHelper {

	static getTour = (storeAddress, deliveryAddress) => {
		return new Promise((resolve, reject) => {
			fetch(`https://rest.viertel-lieferservice.de/orders/fees`, {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json'
				},
				body: JSON.stringify({
					storeAddress: storeAddress,
					order: {
						type: "DELIVERY",
						netValue: 46.73,
						tax: 3.27,
						currency: "EUR",
						deliveryAddress: deliveryAddress
					}
				})
			})
				.then(response => {
					if (response.ok) {
						response.json()
							.then(json => {
								resolve(json.tour)
							})
					}
					else if (response.status === 400) {
						response.text()
							.then(text => {
								reject(text)
							})
					}
				})
				.catch(e => {
					reject(e)
				})
		})

	}
}